"use strict";

module.exports = {
	trackingPath: 'https://api.agentshield.com/t/1x1clear.gif' + '?t=' + (new Date()).getTime(),
    server: 'https://app.agentshield.com',
    restPath: 'https://api.agentshield.com/agent-shield-1.0/rest',
    apiPath: 'https://api.agentshield.com/agent-shield-1.0',
    widgetHost: 'https://widgets.agentshield.com',
    intercomAppId: 'ms2t4wtj',
    intercomAppIdAgent: 'eovn4bxl'
};
